// extracted by mini-css-extract-plugin
export default {"container":"CategoryDiscovery_container__dPjSl","wrapper":"CategoryDiscovery_wrapper__y3Lyr","card":"CategoryDiscovery_card__ll6ox"};